
import React from "react";

const LandingReview = () => {
  return (
    <div className="section-testimonial">
      <div className="padding-global padding-section-large">
        <div className="container-large w-container">
          <div className="text-align-center">
            <h2 className="heading-v1">
              Here’s what our Current Students  have to say...
            </h2>
          </div>
          <div className="results_wrapper">
            <div
              id="w-node-_5165afcc-df9b-1cd6-328a-3a73ea9cc1d2-e2f73468"
              className="results_card-wrapper"
            >
              {/* <div className="results_card secondary">
                <div className="w-embed">
                  <svg
                    width="130"
                    height="130"
                    viewBox="0 0 130 130"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M40.168 51.719C41.842 51.719 43.2783 51.998 44.477 52.556C45.6757 53.0933 46.647 53.8683 47.391 54.881C48.1557 55.873 48.7137 57.02 49.065 58.322C49.437 59.624 49.623 61.019 49.623 62.507V63.809C49.623 67.5703 48.662 70.412 46.74 72.334C44.818 74.2353 41.9867 75.186 38.246 75.186C37.4813 75.186 36.727 75.1653 35.983 75.124C35.239 75.0827 34.5157 75.0207 33.813 74.938V70.691C34.495 70.753 35.2287 70.815 36.014 70.877C36.7993 70.9183 37.6053 70.939 38.432 70.939C40.0853 70.939 41.3873 70.6703 42.338 70.133C43.2887 69.575 43.9603 68.7483 44.353 67.653C44.7457 66.5577 44.942 65.204 44.942 63.592V61.236L46.058 60.492C46.0373 62.042 45.717 63.344 45.097 64.398C44.4977 65.4313 43.6607 66.2063 42.586 66.723C41.5113 67.2397 40.2713 67.498 38.866 67.498C37.2747 67.498 35.9003 67.188 34.743 66.568C33.5857 65.9273 32.697 65.0387 32.077 63.902C31.457 62.7653 31.147 61.422 31.147 59.872C31.147 58.2393 31.519 56.8133 32.263 55.594C33.007 54.354 34.0507 53.4033 35.394 52.742C36.758 52.06 38.3493 51.719 40.168 51.719ZM40.323 55.935C39.4137 55.935 38.6387 56.1003 37.998 56.431C37.378 56.7617 36.8923 57.2163 36.541 57.795C36.2103 58.353 36.045 59.0143 36.045 59.779C36.045 60.5643 36.2103 61.2463 36.541 61.825C36.8717 62.383 37.3367 62.8273 37.936 63.158C38.556 63.468 39.3103 63.623 40.199 63.623C41.005 63.623 41.7387 63.4887 42.4 63.22C43.082 62.9307 43.6193 62.507 44.012 61.949C44.4047 61.3703 44.601 60.647 44.601 59.779C44.601 59.035 44.4357 58.3737 44.105 57.795C43.795 57.2163 43.3197 56.7617 42.679 56.431C42.0383 56.1003 41.253 55.935 40.323 55.935ZM53.1422 75V70.35C53.1422 69.3787 53.2972 68.5313 53.6072 67.808C53.9379 67.0847 54.4546 66.444 55.1572 65.886C55.8599 65.3073 56.7899 64.77 57.9472 64.274L61.6052 62.693C62.5352 62.3003 63.2172 61.8147 63.6512 61.236C64.1059 60.6573 64.3332 59.9237 64.3332 59.035C64.3332 58.1257 64.0542 57.3817 63.4962 56.803C62.9382 56.2243 62.1219 55.935 61.0472 55.935C59.9726 55.935 59.1562 56.2347 58.5982 56.834C58.0402 57.4333 57.7612 58.2393 57.7612 59.252H52.8322C52.8322 57.826 53.1422 56.5447 53.7622 55.408C54.3822 54.2507 55.3019 53.3413 56.5212 52.68C57.7406 52.0187 59.2492 51.688 61.0472 51.688C62.8452 51.688 64.3436 52.0083 65.5422 52.649C66.7616 53.2897 67.6812 54.1473 68.3012 55.222C68.9419 56.2967 69.2622 57.5057 69.2622 58.849V59.221C69.2622 60.957 68.7869 62.3933 67.8362 63.53C66.8856 64.646 65.4182 65.638 63.4342 66.506L59.8072 68.087C59.1872 68.3557 58.7429 68.6347 58.4742 68.924C58.2262 69.2133 58.1022 69.606 58.1022 70.102V71.652L56.8932 70.629H69.2932V75H53.1422ZM78.5261 75L86.7721 52.37H90.9261L82.7111 75H78.5261ZM76.9761 64.801C75.7568 64.801 74.7338 64.5323 73.9071 63.995C73.1011 63.437 72.4915 62.7033 72.0781 61.794C71.6855 60.864 71.4891 59.841 71.4891 58.725V57.919C71.4891 56.741 71.6958 55.6973 72.1091 54.788C72.5225 53.8787 73.1425 53.1657 73.9691 52.649C74.7958 52.1323 75.7981 51.874 76.9761 51.874C78.1748 51.874 79.1771 52.1323 79.9831 52.649C80.8098 53.1657 81.4298 53.8787 81.8431 54.788C82.2565 55.6973 82.4631 56.741 82.4631 57.919V58.725C82.4631 59.841 82.2565 60.864 81.8431 61.794C81.4505 62.7033 80.8511 63.437 80.0451 63.995C79.2391 64.5323 78.2161 64.801 76.9761 64.801ZM76.9761 61.484C77.6168 61.484 78.0818 61.2567 78.3711 60.802C78.6811 60.3267 78.8361 59.5103 78.8361 58.353C78.8361 57.1337 78.6811 56.2967 78.3711 55.842C78.0611 55.3873 77.5961 55.16 76.9761 55.16C76.3561 55.16 75.8911 55.3873 75.5811 55.842C75.2711 56.2967 75.1161 57.1233 75.1161 58.322C75.1161 59.4793 75.2711 60.2957 75.5811 60.771C75.8911 61.2463 76.3561 61.484 76.9761 61.484ZM92.3831 75.527C91.1431 75.527 90.1201 75.2583 89.3141 74.721C88.5081 74.1837 87.8985 73.4603 87.4851 72.551C87.0925 71.621 86.8961 70.598 86.8961 69.482V68.676C86.8961 67.4773 87.1028 66.4233 87.5161 65.514C87.9295 64.6047 88.5391 63.8917 89.3451 63.375C90.1718 62.8583 91.1845 62.6 92.3831 62.6C93.5818 62.6 94.5841 62.8583 95.3901 63.375C96.1961 63.8917 96.8058 64.6047 97.2191 65.514C97.6325 66.4233 97.8391 67.4773 97.8391 68.676V69.482C97.8391 70.598 97.6325 71.621 97.2191 72.551C96.8265 73.4603 96.2271 74.1837 95.4211 74.721C94.6358 75.2583 93.6231 75.527 92.3831 75.527ZM92.3831 72.241C93.0238 72.241 93.4888 72.0137 93.7781 71.559C94.0881 71.0837 94.2431 70.2673 94.2431 69.11C94.2431 67.87 94.0881 67.033 93.7781 66.599C93.4681 66.1443 93.0031 65.917 92.3831 65.917C91.7631 65.917 91.2878 66.1443 90.9571 66.599C90.6471 67.033 90.4921 67.8597 90.4921 69.079C90.4921 70.2363 90.6471 71.0527 90.9571 71.528C91.2671 72.0033 91.7425 72.241 92.3831 72.241Z"
                      fill="#f99b37"
                    />
                    <circle
                      cx="65"
                      cy="64.8731"
                      r="61.082"
                      stroke="#000"
                      strokeWidth="6"
                    />
                    <mask id="path-3-inside-1_1529_1204" fill="white">
                      <path d="M65.0001 3.10668C65.0001 1.3909 66.3921 -0.00778488 68.1059 0.0743378C81.2847 0.705776 93.9859 5.34388 104.492 13.4058C115.822 22.0994 123.967 34.2885 127.663 48.0827C131.359 61.8769 130.4 76.5053 124.935 89.699C119.47 102.893 109.804 113.915 97.4367 121.055C85.0692 128.195 70.6911 131.055 56.5325 129.191C42.3739 127.327 29.2259 120.843 19.1279 110.745C9.02983 100.647 2.54598 87.4995 0.681954 73.3408C-1.04663 60.211 1.28722 46.8924 7.32979 35.1635C8.11559 33.6382 10.0229 33.1321 11.5088 33.99C12.9947 34.8478 13.4958 36.7446 12.7177 38.2739C7.35465 48.8148 5.29217 60.7562 6.84219 72.5298C8.52769 85.3324 14.3905 97.221 23.5214 106.352C32.6523 115.483 44.541 121.346 57.3435 123.031C70.1461 124.717 83.147 122.131 94.33 115.674C105.513 109.217 114.253 99.2513 119.195 87.3213C124.136 75.3912 125.003 62.1639 121.661 49.6909C118.319 37.2179 110.955 26.1962 100.71 18.3352C91.2887 11.1061 79.9159 6.92154 68.1056 6.29561C66.3923 6.2048 65.0001 4.82246 65.0001 3.10668Z" />
                    </mask>
                    <path
                      d="M65.0001 3.10668C65.0001 1.3909 66.3921 -0.00778488 68.1059 0.0743378C81.2847 0.705776 93.9859 5.34388 104.492 13.4058C115.822 22.0994 123.967 34.2885 127.663 48.0827C131.359 61.8769 130.4 76.5053 124.935 89.699C119.47 102.893 109.804 113.915 97.4367 121.055C85.0692 128.195 70.6911 131.055 56.5325 129.191C42.3739 127.327 29.2259 120.843 19.1279 110.745C9.02983 100.647 2.54598 87.4995 0.681954 73.3408C-1.04663 60.211 1.28722 46.8924 7.32979 35.1635C8.11559 33.6382 10.0229 33.1321 11.5088 33.99C12.9947 34.8478 13.4958 36.7446 12.7177 38.2739C7.35465 48.8148 5.29217 60.7562 6.84219 72.5298C8.52769 85.3324 14.3905 97.221 23.5214 106.352C32.6523 115.483 44.541 121.346 57.3435 123.031C70.1461 124.717 83.147 122.131 94.33 115.674C105.513 109.217 114.253 99.2513 119.195 87.3213C124.136 75.3912 125.003 62.1639 121.661 49.6909C118.319 37.2179 110.955 26.1962 100.71 18.3352C91.2887 11.1061 79.9159 6.92154 68.1056 6.29561C66.3923 6.2048 65.0001 4.82246 65.0001 3.10668Z"
                      stroke="#f99b37"
                      strokeWidth="12"
                      strokeLinejoin="round"
                      mask="url(#path-3-inside-1_1529_1204)"
                    />
                  </svg>
                </div>
                <p className="text-color-white titlium-font">
                  of customers were served successfully*
                </p>
              </div> */}
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                  The best pick of the cohort was the Story Telling Technique
                  for recruiters. Ashfaq has structured the course will which
                  gave us an understanding on What, Why, How in recruitment.
                </p>
                <div className="results_info">
                  <img
                    src="https://recruitingmonk.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fdebin.3e605a84.png&w=640&q=75"
                    loading="lazy"
                    alt="true"
                    className="results_img"
                  />
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/debin-dennis-86b27447/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                  Indeed one of its kind coaching-well structured and detailed,
                  with such deep insights and a completely new outlook towards
                  our day to day work. So delighted to be a part of it. Amazing
                  beginning and looking forward to much more exciting learning
                  ahead!!
                </p>
                <div className="results_info">
                  <img
                    src="https://recruitingmonk.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fshikha.9f9ef1f5.png&w=640&q=75"
                    loading="lazy"
                    alt="true"
                    className="results_img"

                  />
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/shikha-abrol/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div
              id="w-node-_5165afcc-df9b-1cd6-328a-3a73ea9cc1ef-e2f73468"
              className="results_card-wrapper"
            >
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                  It's a great platform for tech recruiters. Trainer was
                  brilliant in sharing some great tips and tricks about putting
                  up searches. live sessions and all QnA were a great help in
                  covering many doubts.
                </p>
                <div className="results_info">
                  <img
                    src="https://recruitingmonk.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fprabh.fa657b5f.png&w=640&q=75"
                    loading="lazy"
                    alt="true"
                    className="results_img"

                  />
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/prabhjot-kaur-a5911843/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>

              </div>
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                I sincerely appreciate the exceptional guidance and support that Ashfaq has consistently provided me throughout the entire duration of the Program. His unwavering commitment, insightful advice, and genuine care for my progress have been truly remarkable.
                </p>
                <div className="results_info">
                  <img
                    src="https://recruitingmonk.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fmenon.8e6350b8.png&w=640&q=75"
                    loading="lazy"
                    alt="true"
                    className="results_img"

                  />
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/achyutmenon/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div
              id="w-node-_5165afcc-df9b-1cd6-328a-3a73ea9cc214-e2f73468"
              className="results_card-wrapper"
            >
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                  "Ashfaq, I must say, you are the best trainer and recruiter I
                  have ever came across. I am so lucky that I have enrolled the
                  course, it covers all the aspects that one recruiter should
                  know.. Looking forward for the next training 😃 You are
                  awesome buddy 🙌"
                </p>
                <div className="results_info">
                  <img
                    src="https://recruitingmonk.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Faditi.d7b92211.png&w=640&q=75"
                    loading="lazy"
                    alt="true"
                    className="results_img"

                  />
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/adisharma26/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="results_card">
                <div className="w-embed">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 17.3245C0 21.1391 2.9404 24 6.6755 24C10.4106 24 13.351 21.1391 13.351 17.3245C13.351 14.702 11.9205 12.4768 9.77484 11.4437L14.2252 0H7.94702L2.06623 11.4437C0.715232 14.0662 0 15.7351 0 17.3245ZM17.0066 17.3245C17.0066 21.1391 19.947 24 23.6821 24C27.4967 24 30.3576 21.1391 30.3576 17.3245C30.3576 14.702 28.9272 12.4768 26.7815 11.4437L31.2318 0H24.9536L19.0729 11.4437C17.7219 14.0662 17.0066 15.7351 17.0066 17.3245Z"
                      fill="#f99b37"
                    />
                  </svg>
                </div>
                <p className="line-height-180">
                  "Ashfaq is one Amazing mentor. All his teachings really helped
                  us & ensured we compete equally with experience Recruiters.
                  This has been an amazing team and great learning experience.
                  Made some really good friends."
                </p>
                <div className="results_info">
                  <img
                    src="https://uploads-ssl.webflow.com/62455510264ca642dfb4e99e/627a4d405e56e54ff8e81092_sai.jpg"
                    loading="lazy"
                    alt="true"
                    style={{width:"78px", height:"78px", borderRadius:"50%"}}
                  />
                  <div className="div-block-3">
                    <p className="text-weight-bold text-size-medium">
                      Sai sandeep
                    </p>
                    <p className="result_subheading" style={{color:"#626161", fontStyle:"italic"}}>Senior Associate HR</p>
                    <p className="result_subheading" style={{color:"#626161", fontStyle:"italic"}}>
                    @ITILITE
                    </p>
                  </div>
                  <a style={{marginTop:"5px"}}
                   href="https://www.linkedin.com/in/sai-sandeep-puriya-63bb961a0/"
                   target="_blank">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <path
                        fill="#0A66C2"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 0 1-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 0 0 2 2.866v10.268a.88.88 0 0 0 .885.866h10.226a.882.882 0 0 0 .889-.866V2.865a.88.88 0 0 0-.889-.864z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="section-offer">
            <h3 className="text-size-large text-align-center">
            Master the magic of storytelling, captivating hearts and minds. 
            </h3>
            <div className="offer">
            <div className="hero_heighlight1">
                <div className="heighlight_card1">
                  <div className="html-embed w-embed timedate">
                  <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.75 2.5a.75.75 0 0 0-1.5 0v1.5793c-1.4393.1152-2.3842.398-3.0784 1.0923-.6942.6942-.977 1.639-1.0923 3.0784h19.8414c-.1152-1.4393-.3981-2.3842-1.0923-3.0784-.6942-.6942-1.6391-.977-3.0784-1.0923V2.5a.75.75 0 0 0-1.5 0v1.5129C15.5847 4 14.839 4 14 4h-4c-.839 0-1.5847 0-2.25.0129V2.5Z" fill="#000000"/><path fillRule="evenodd" clipRule="evenodd" d="M2 12c0-.839 0-1.5847.0129-2.25h19.9742C22 10.4153 22 11.161 22 12v2c0 3.7712 0 5.6569-1.1716 6.8284C19.6569 22 17.7712 22 14 22h-4c-3.7712 0-5.6569 0-6.8284-1.1716C2 19.6569 2 17.7712 2 14v-2Zm15 2c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm0 4c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm-4-5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Zm0 4c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Zm-6-3c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm0 4c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z" fill="#000000"/></svg>
                    <p style={{color:"white", fontWeight:"bold"}}>Date : 22nd & 23rd July</p>
                  </div>

                  <div className="html-embed w-embed timedate">
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10Z"
                        fill="#000"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 7.25a.75.75 0 0 1 .75.75v3.6893l2.2803 2.2804a.75.75 0 0 1 0 1.0606.75.75 0 0 1-1.0606 0l-2.5-2.5A.7497.7497 0 0 1 11.25 12V8a.75.75 0 0 1 .75-.75Z"
                        fill="#fff"
                      />
                    </svg>
                    <p style={{color:"white", fontWeight:"bold"}}>Time : 7.00PM - 8.30PM</p>
                  </div>
                </div>
              </div>
              <button
                className="button is-secondary text-color-red no-wrap w-button"
                style={{color:"#000"}}
              >
                Register today for ₹1,599.00
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingReview;
